export interface LossState{
    badge?: string
    productDescription?: string
    addressList?: LocationsApiResult[]
    selectLocation?: number
}

export enum LossTypes{
    MATURATION = 'amadurecimento',
    DAMAGE = 'dano',
    EXPIRATION_DATE = 'validade',
}

export enum LossDestination{
    SALE = 'venda',
    DISCARD = 'descarte',
    DONATION = 'doação',
}

export interface AddressInfo {
    street?: string,
    shed?: string,
    shelf?: string,
    bin?: string,
}

export interface DamageBatch {
    quantity: number,
    type: LossTypes,
    destination: LossDestination,
    expiration_date: string,
    reason: string,
    id_batch: number,
    id_stock: number,
    address_info: AddressInfo,
    batch_stock_id: number,
}

export interface LossApiPayload{
    id_model?: number,
    product_code?: string,
    damage_batches?: DamageBatch[],
    id_location?: number,
}

export interface ValidateSupervisorBadgeParams{
    badge: string,
    setError: (error: string) => void,
    onSuccess: () => void
}

export enum GenericApiErrors{
    Failed
}

export interface ProductLocation{
    barcode: string,
    fcId: string
    setError: (error: string) => void,
    onSuccess: () => void,
}

export interface LocationsApiResult{
    id: number,
    description: string
    batches: ProductInformationApiResult[]
    shed: string
    street: string
    shelf: string
    bin: string
    productCode: string
    idModel: number
}

export interface ProductInformationApiResult {
    quantity: number,
    expirationDate: Date,
    idLocation: number,
    idBatch: number,
    idStock: number,
    batchStockId: number,
}

export interface productDescriptionDto {
    barcode: string,
    getProductList: () => void,
    onSuccess: () => void
}

export interface LossAdjustmentPayload {
    badge: string | undefined,
    batches: LossApiPayload,
}

export interface LossDto {
    LossAdjustment: LossAdjustmentPayload
    onSuccess: () => void
    reset: () => void
}

export interface UpdateLossState {
    key: keyof LossState;
    value: LossState[keyof LossState];
}

export interface FormData {
    quantity: number,
    type: LossTypes,
    destination: LossDestination,
    expiration_date: string,
    id_localization: number,
    reason: string
    id_batch: number,
    id_stock: number,
    batch_stock_id: number,
}

export interface FormDataItems {
    items: FormData[]
}
